/*
Permission config
 */

// Roles
export enum ROLE_NAMES {
    ROLE_ADMIN = import.meta.env.VITE_KEYCLOAK_ROLE_ADMIN,
    ROLE_EMPLOYEE = import.meta.env.VITE_KEYCLOAK_ROLE_EMPLOYEE,
    ROLE_CUSTOMER = import.meta.env.VITE_KEYCLOAK_ROLE_CUSTOMER
}

// Asserted to plain `string[]` (not `(string | ROLE_NAMES)[]`, which `Object.values` on this
// computed-member enum infers) - `pg-frontend-vue`'s `RouteMeta.hasAnyPermission?: string[]`
// augmentation requires exactly `string[]`, and TS doesn't consider `ROLE_NAMES` structurally
// assignable to `string` even though every member's runtime value genuinely is one (each is
// `import.meta.env.VITE_KEYCLOAK_ROLE_*`) - a plain annotation doesn't widen an incompatible
// initializer, so this needs an actual assertion.
const ALL_ROLES = Object.values(ROLE_NAMES) as string[];

// Feature permissions
export const PERMISSIONS_DOCUMENT_SEARCH = ALL_ROLES;
export const PERMISSIONS_DOCUMENT_DOWNLOAD = ALL_ROLES;

// Download limits
export const DOWNLOAD_LIMIT_DEFAULT = 20;
